// customization engine handles frontend changes, namely modifying the appierance of plugins to follow CJC styling

// import your class here
import podiumCustomizer from './customization-engine-podium-button.js?v=1.10'
import accessibilityCustomizer from "./customization-engine-accessibility-button.js?v=1.8"
import wishlistCustomizer from './customization-engine-wishlist-button.js?v=1.1';
//import wishlistButtonCustomizer from './customization-engine-wishlist-newproduct-button.js';

// this file handles initialization and mutation observers for all customizations
class customizationEngine {
    mutateMap = new Map();
    pageObserver = null;
    
    page = document.documentElement;
    mutConf = {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
    }

    standardMutationFunction = (mutationList, observer) => { // standard init scripting
        for(const mut of mutationList){
            if(mut.type !== 'childList' && !(mut.addedNodes.length > 0)) continue; // skip any muts that dont add something
            for(const node of mut.addedNodes){
                if(node.nodeType !== Node.ELEMENT_NODE) continue;

                for(let [selector, classType] of this.mutateMap){
                    // when there is a mutation, check what type, instantiate that class type
                    const targetElement = node.matches(selector) ? node : node.querySelector(selector);
                
                    if (targetElement) {
                        console.log(`found ${selector} element, binding module ${classType.name}`);
                        // Pass the actual target element, NOT the high-level mutation node
                        new classType(targetElement); 
                    } 
                }
            }
        }
    } 

    constructor(){
        console.log("customization engine loaded");

        // similar to generic-interactive, if adding a new module put a selector + class into this hashmap
        this.mutateMap.set("#podium-bubble", podiumCustomizer);
        this.mutateMap.set("#accessiblyAppDialogButton", accessibilityCustomizer);
        this.mutateMap.set('a[aria-label="Open Wishlist"]', wishlistCustomizer);
//        this.mutateMap.set('.wishlist-hero-custom-button', wishlistButtonCustomizer);

        // start with standard mutation functions
        this.init(this.standardMutationFunction);
    }

    init(callback) {
        // setup page wide mutation observer, running passed function
        this.pageObserver = new MutationObserver(callback);
        this.pageObserver.observe(this.page, this.mutConf);
    }
}

new customizationEngine(); // actaully init
